// 中英文切换
import Vue from "vue";
// import ElementUI from 'element-ui';
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import zhcnLocale from "element-ui/lib/locale/lang/zh-CN"; //中文
import enLocale from "element-ui/lib/locale/lang/en"; //英语
import tnLocale from "element-ui/lib/locale/lang/th"; //泰语
import zhcnLocaleTW from "element-ui/lib/locale/lang/zh-TW"; //中午繁体
import esLocale from "element-ui/lib/locale/lang/es";
import frLocale from "element-ui/lib/locale/lang/fr";
import ind from "element-ui/lib/locale/lang/id";

zhcnLocale.el.pagination = {
  goto: "前往",
  pagesize: "/页",
  total: `共 {total} 条`,
  pageClassifier: "页",
};

enLocale.el.pagination = {
  goto: "Go to",
  total: `totally {total} item`,
  pagesize: "/page",
  pageClassifier: "",
};

tnLocale.el.pagination = {
  pagesize: "/หน้า",
  total: `รวม {total} รายการ`,
  goto: "ไป",
  pageClassifier: "",
};

zhcnLocaleTW.el.pagination = {
  //繁体
  goto: "前往",
  pagesize: "/頁",
  total: `共 {total} 條`,
  pageClassifier: "頁",
};

esLocale.el.pagination = {
  //西班牙语
  pagesize: "/Página",
  total: `Total {total} mensajes`,
  goto: "Ir",
  pageClassifier: "Página",
};

frLocale.el.pagination = {
  //法语
  pagesize: "/page",
  total: `Total {total} articles`,
  goto: "Aller",
  pageClassifier: "page",
};

// Vue.use(ElementUI, {
//     // size: 'small',
//     locale: {
//         el: {
//             // 整体覆盖
//             ...enLocale.el,
//             pagination: {
//                 pagesize: '/page',
//                 total: `totally {total} items`,
//                 goto: 'Go to',
//                 pageClassifier: ''
//             },
//         }
//     }
// })

import nextEn from "./en.js";
import nextZh from "./zh.js";
import nextTn from "./tn.js";
import nextFn from "./fn.js";
import nextEpn from "./epn.js";
import nextTW from "./zh-TW.js";
import nextInd from "./ind.js";
const i18n = new VueI18n({
  locale: localStorage.getItem("languageStorage") || window.XINPOC_DISPATCH_CONFIG.defaultLanguage,
  messages: {
    zh: {
      ...zhcnLocale,
      message: {
        ...nextZh,
      },
    },
    en: {
      ...enLocale,
      message: {
        ...nextEn,
      },
    },
    tn: {
      ...tnLocale,
      message: {
        ...nextTn,
      },
    },
    zhTW: {
      ...zhcnLocaleTW,
      message: {
        ...nextTW,
      },
    },
    epn: {
      ...esLocale,
      message: {
        ...nextEpn,
      },
    },
    fn: {
      ...frLocale,
      message: {
        ...nextFn,
      },
    },
    ind: {
      ...ind,
      message: {
        ...nextInd,
      },
    },
  },
});

export default i18n;
